module.exports = __webpack_public_path__ + "static/media/1015.e567daf0.jpg";